import { useMemo, useState, useEffect, useCallback } from 'react'
import { useSelector } from 'react-redux';
import { useValidateWhatsAppNumberMutation } from '../api/chatApi';
import { filterContacts, formatContactName, formatePhoneNumber } from '../../../utils/helpers';

const NewConversation = ({onClose, contactState,selectedId}) => {
  const session = useSelector((state) => state.auth?.session);
  const contactList = useSelector((state) => state.chat?.contacts);
  const [searchTerm, setSearchTerm] = useState('');
  const { selectContact, setSelectContact } = contactState;
  const [validateWhatsappPhoneApi] = useValidateWhatsAppNumberMutation();
  const [checkingNumber, setCheckingNumber] = useState(false);
  const [numberResult, setNumberResult] = useState(null);
  
  const sortedContacts = useMemo(() => {
    const contacts = [...contactList].sort((a, b) => b.createdAt.localeCompare(a.createdAt));    
    if (!searchTerm.trim()) return contacts;
    
    return filterContacts(contacts, searchTerm);
  }, [contactList, searchTerm]);

  const checkNumber = useCallback(async () => {
    if (!searchTerm.trim() || sortedContacts.length > 0) {
      setNumberResult(null);
      return;
    }

    setCheckingNumber(true);
    try {
      const response = await validateWhatsappPhoneApi({
        user_id: selectedId,
        phone_number: searchTerm
      }).unwrap();

      if (response?.data) {
        setNumberResult(response.data);
      }
    } catch {
      setNumberResult(null);
    } finally {
      setCheckingNumber(false);
    }
  }, [searchTerm, sortedContacts.length, selectedId, validateWhatsappPhoneApi]);

  useEffect(() => {
      const searchDebouncing = setTimeout(() => {
        checkNumber();
      }, 1000)

      return () => clearTimeout(searchDebouncing);
  }, [searchTerm, checkNumber]);


  return (
    <div style={{margin: '0 10px'}} className='contact_container'>
        <div className="back-btn" style={{padding: '10px', background: '#f9eded'}}>
            <img src="/arrow.png" alt="" onClick={onClose}/>
            <h4>New Chat</h4>
        </div>
        <input
          type="text"
          placeholder="Search number"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className='search_input'
          style={{width: '100%', margin: '10px auto'}}
        />

      <div className='scrollContainer scrollable_list'>
        {sortedContacts.length > 0 ? (
          <>
            <p className='list_label'>Contacts on Whatsapp</p>
            {sortedContacts.map(contact => {
              const contactName = formatContactName(contact.name, contact.push_name);
              return (
                <div 
                key={`${contact.id} - ${contact.wa_id}`} 
                className={`contactCard ${selectContact?.wa_id === contact.wa_id ? 'active' : ''}`} 
                onClick={() => {
                  setSelectContact(contact)
                  onClose()
                }}
              >
                <div className='contact_body'>
                  <strong>
                    {session?.phone_number === contact.name 
                      ? `${contact.name} (You)` 
                      : contactName
                    }
                  </strong>
                  {!contactName?.startsWith('+') && !contact.is_group && <p>{formatePhoneNumber(contact.wa_id)}</p>}
                </div>
              </div>
              )
            })}
          </>
        ) : checkingNumber ? (
          <div style={{ textAlign: 'center', marginTop: '20px', color: '#888' }}>
            Checking number...
          </div>
        ) : numberResult ? (
          <>
            <p className='list_label'>Not in your Contacts</p>
            <div
              className='contactCard'
              onClick={() => {
                setSelectContact({ 
                  wa_id: numberResult?.id, 
                  name: numberResult?.id.split('@')[0]
                });
                setSearchTerm('');
                onClose();
              }}
            >
              <div className='contact_body'>
                <strong>{numberResult?.id.split('@')[0]}</strong>
              </div>
            </div>
          </>
        ) : (
          <div style={{ textAlign: 'center', marginTop: '20px', color: '#888' , fontSize: '18px'}}>
            No results found for '{searchTerm.trim()}''
          </div>
        )}
      </div>
    </div>
  )
}

export default NewConversation;
